<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="materialsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'materials-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="number"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Materials</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="numberTemplate" [sortOrder]="'asc'"></dxi-column>
            <dxi-column [dataField]="gridFieldName('description')" caption="Description" [minWidth]="200"></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('created')"
                caption="Date Added"
                [minWidth]="100"
                dataType="date"
                selectedFilterOperation=">="
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('business')" caption="Business" [minWidth]="120"></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('storageType')"
                caption="Storate Type"
                [lookup]="{ dataSource: binTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
                [minWidth]="120"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('corporateBrandDescription')" caption="Brand Description" [minWidth]="150"></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('status')"
                caption="Status"
                [lookup]="{ dataSource: materialStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                [minWidth]="180"
                cellTemplate="statusTemplate"
            ></dxi-column>

            <dxi-column [dataField]="gridFieldName('actualStorageType')" caption="Actual Storage Type" [visible]="false" [lookup]="{ dataSource: binTypeOptions, valueExpr: 'value', displayExpr: 'text' }"></dxi-column>
            <dxi-column [dataField]="gridFieldName('clientTotShelfLife')" caption="Client Tot Shelf Life" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('grossWeight')" caption="Gross Weight" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('netWeight')" caption="Net Weight" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('weightType')" caption="Weight Type" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('unit')" caption="Unit" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('salesUnit')" caption="Sales Unit" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('eachesPerSalesUnit')" caption="Eaches Per Sales Unit" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('piecesPerPallet')" caption="Pieces Per Pallet" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('casesPerLayer')" caption="Cases Per Layer" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('casesPerPallet')" caption="Cases Per Pallet" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('layersPerPallet')" caption="Layers Per Pallet" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('stackingFactor')" caption="Stacking Factor" [visible]="false" dataType="number" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('category')" caption="Category" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('categoryDescription')" caption="Category Description" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('hierarchyDescription')" caption="Hierarchy Description" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('nationalPrice')" caption="National Price" [visible]="false" dataType="number" format="currency" selectedFilterOperation=">="></dxi-column>
            <dxi-column [dataField]="gridFieldName('corporateBrand')" caption="Corporate Brand" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('rangeBrand')" caption="Range Brand" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('rangeBrandDescription')" caption="Range Brand Description" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('materialGroup')" caption="Material Group" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('materialGroupDescription')" caption="Material Group Description" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('nestecProductCategoryName')" caption="Nestec Product Category Name" [visible]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('originDescription')" caption="Origin Description" [visible]="false"></dxi-column>

            <div *dxTemplate="let cellInfo of 'numberTemplate'">
                <div class="text-primary fw-semibold">
                    <a [routerLink]="`/inventory/materials/details/${getCellData(cellInfo).number}`"
                       class="text-decoration-none">{{ getCellData(cellInfo).number }}</a>
                </div>
            </div>

            <div *dxTemplate="let cellInfo of 'statusTemplate'">
                 <span class="badge" [ngClass]="getStatusBadgeClass(cellInfo.value)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('number')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'ID', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('description')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Description', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('business')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Business', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: materialStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('storageType')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: binTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Storage Type', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('corporateBrandDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Brand Description', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('actualStorageType')" editorType="dxSelectBox" [editorOptions]="{ items: binTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Actual Storage Type', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('clientTotShelfLife')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Client Tot Shelf Life', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('grossWeight')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Gross Weight', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('netWeight')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Net Weight', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('weightType')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Weight Type', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('unit')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Unit', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('salesUnit')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Sales Unit', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('eachesPerSalesUnit')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Eaches Per Sales Unit', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('piecesPerPallet')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Pieces Per Pallet', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('casesPerLayer')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Cases Per Layer', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('casesPerPallet')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Cases Per Pallet', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('layersPerPallet')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Layers Per Pallet', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('stackingFactor')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'Stacking Factor', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('category')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Category', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('categoryDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Category Description', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('hierarchyDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Hierarchy Description', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('nationalPrice')" editorType="dxNumberBox" [editorOptions]="{ placeholder: 'National Price', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('corporateBrand')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Corporate Brand', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('rangeBrand')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Range Brand', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('rangeBrandDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Range Brand Description', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('materialGroup')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Material Group', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('materialGroupDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Material Group Description', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('nestecProductCategoryName')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Nestec Product Category Name', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('originDescription')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Origin Description', stylingMode: 'filled' }"></dxi-item>
        </dx-form>
    </filter-panel>
</div>
